import { Checkbox, InputNumber } from "antd";
import { FC, memo, useEffect, useState } from "react";

interface IProps {
  value: number;
  onChange: (value: number | null) => void;
}

const TimeLimit: FC<IProps> = (props) => {
  const { value, onChange } = props;

  const [checked, setChecked] = useState(false);
  const [inputValue, setInputValue] = useState<number | null>();

  const onInputChange = (value: number | null) => {
    if (!value) return;
    onChange(value);
  }

  const onCheckChange = () => {
    if (value === -1) {
      onChange(null);
    } else {
      onChange(-1);
    }
  }

  useEffect(() => {
    if (!value) return;
    if (value === -1) {
      setChecked(true);
      setInputValue(null);
    } else {
      setChecked(false);
      setInputValue(value);
    }
  }, [value]);
  
  return (
    <span>
      <InputNumber
        type="text"
        // value={value.number || number}
        // onChange={onNumberChange}
        style={{
          width: 100,
        }}
        value={inputValue}
        onChange={onInputChange}
        min={0}
      />
      {` 小时`}
      ｜
      <Checkbox checked={checked} onChange={onCheckChange}>不限时</Checkbox>
    </span>
  )
}

export default memo(TimeLimit);